import React from "react";
import { Box, Typography } from "@mui/material";

import "./comingSoon.css";

const ComingSoon = ({ title, desc, img }) => {
  return (
    <Box className="comingSoonMain" textAlign={"center"} my={4}>
      <img src={img} alt="comingsoon" />
      <Typography variant="h5" mt={3} mb={1}>
        {title}
      </Typography>
      <Typography>{desc}</Typography>
    </Box>
  );
};

export default ComingSoon;
